jQuery(document).ready(function(){

  jQuery('.banner-slider').slick({
  dots: true,
  arrows: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true,
  });
 jQuery('.proshop-banner').slick({
  dots: true,
  arrows: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true,
  });

  jQuery('.review-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    // autoplay: true,
    autoplaySpeed: 2000,
    dots: true,
    arrows: false,
     responsive: [
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }

    ]

  });
 
});

setTimeout(function() {
  jQuery('.globo-formbuilder-wizard > div.wizard__content > p').remove();
}, 2000);

/* pro-shop page search bar */
jQuery('.close-icon-search').on('click',function(){
   jQuery('ul.all_collection-lists').hide();
   jQuery('.close-icon-search i').addClass('fa-magnifying-glass');
      jQuery('.close-icon-search i').removeClass('fa-xmark');
      jQuery(".custom-col_seacrh").val("");
   
});

 jQuery('.custom-col_seacrh').on('click', function() {  
       jQuery('ul.all_collection-lists').show();
       jQuery('.close-icon-search i').addClass('fa-xmark');
      jQuery('.close-icon-search i').removeClass('fa-magnifying-glass');

      jQuery('ul.all_collection-lists li').each(function() {
                        jQuery(this).show();
            });

            jQuery('li.not_result_found').hide();
   
    });

jQuery('.custom-col_seacrh').on('input', function() {
jQuery('ul.all_collection-lists').hide();
        var searchText = jQuery(this).val().toLowerCase();
        var $listItems = jQuery('ul.all_collection-lists li');
         var anyMatched = false;

        if (searchText.length >= 3) {
            jQuery('ul.all_collection-lists').show();
            $listItems.each(function() {
                var listItemText = jQuery(this).text().toLowerCase();
                if (listItemText.includes(searchText)) {
                        jQuery(this).show();
                  anyMatched = true;
                } else {
                    jQuery(this).hide();
                }
            });
           if (!anyMatched) {

               if(jQuery('li.not_result_found').length > 0){
                jQuery('li.not_result_found').show();
               }else{
                jQuery('ul.all_collection-lists').append('<li class="not_result_found">No results found</li>');
               }
            }
        }
    });
/* end */

jQuery('.custom_seacrh').on('click',function(){
  jQuery('.close-product-search i').addClass('fa-xmark');
      jQuery('.close-product-search i').removeClass('fa-magnifying-glass');
});
jQuery('.close-product-search').on('click',function(){
  jQuery('ul.all_product-lists').hide();
  jQuery('.close-product-search i').addClass('fa-magnifying-glass');
      jQuery('.close-product-search i').removeClass('fa-xmark');
        jQuery(".custom_seacrh").val("");
});